export default __webpack_public_path__ + "static/streaming-dark-e62ca02c82e8f1ce79fb9d0f14066092.png";